export default "__VITE_ASSET__Bw68eFU1__"